import React from 'react';
import styled from 'styled-components';
import theme from '../../../assets/css/theme';

const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  height: 55px;
  padding: 4px;
  border: 1px solid ${theme.formsColors.mainBorderColor};
  border-radius: 28px;
  box-sizing: border-box;
  overflow: hidden;
`;

const Segment = styled.button<{ $isActive: boolean }>`
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 0.75vw, 8px);
  padding: 6px clamp(4px, 1vw, 12px);
  border: 2px solid ${(props) => (props.$isActive ? theme.commonColors.second : 'transparent')};
  border-radius: 24px;
  background: ${(props) => (props.$isActive ? '#5C876224' : 'transparent')};
  color: ${(props) => (props.$isActive ? theme.commonColors.main : '#9a9a9a')};
  font-size: ${theme.fontSizes.body};
  font-weight: ${(props) => (props.$isActive ? 500 : 400)};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: ${theme.commonColors.main};
  }

  svg {
    width: clamp(16px, 1.4vw, 20px);
    height: clamp(16px, 1.4vw, 20px);
    flex-shrink: 0;
  }
`;

const SegmentLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export interface ISegmentedOption {
  value: string;
  label: string;
  /** SVG imported with the `?react` svgr suffix */
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
}

interface IProps {
  /** An empty string means "no explicit choice" — no segment is highlighted. */
  value: string;
  options: ISegmentedOption[];
  onChange: (value: string) => void;
  id?: string;
}

export const SegmentedControl = ({ value, options, onChange, id }: IProps) => (
  <Wrapper id={id} role="group">
    {options.map(({ value: optionValue, label, Icon }) => (
      <Segment
        key={optionValue}
        type="button"
        $isActive={value === optionValue}
        aria-pressed={value === optionValue}
        onClick={() => onChange(optionValue)}
        data-cy={`segmented-${id || 'control'}-${optionValue}`}
      >
        {Icon && <Icon />}
        <SegmentLabel>{label}</SegmentLabel>
      </Segment>
    ))}
  </Wrapper>
);

export default SegmentedControl;
